import { render, staticRenderFns } from "./item.vue?vue&type=template&id=5e911778&scoped=true"
import script from "./item.vue?vue&type=script&lang=ts"
export * from "./item.vue?vue&type=script&lang=ts"
import style0 from "./item.vue?vue&type=style&index=0&id=5e911778&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e911778",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ViewMore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/view-more.vue').default})
